<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />
        <h2 class="brand-text text-primary ml-1">
          Harber
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            Bienvenido a Harber ERP
          </b-card-title>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >
              <!-- email -->
              <b-form-group
                label="Email"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="email@harberlondon.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Contraseña</label>

                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- 2FA: solo si el usuario lo tiene activado -->
              <b-form-group
                v-if="requiere2fa"
                label="Código de verificación"
                label-for="login-codigo"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Código"
                  rules="required"
                >
                  <b-form-input
                    id="login-codigo"
                    v-model="codigo"
                    :state="errors.length > 0 ? false:null"
                    name="login-codigo"
                    inputmode="numeric"
                    autocomplete="one-time-code"
                    maxlength="6"
                    placeholder="123456"
                    autofocus
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small class="text-muted d-block">Introduce el código de 6 dígitos de tu app de autenticación.</small>
                </validation-provider>
              </b-form-group>

              <p v-if="errores != ''" style="color: red">{{ errores }}</p>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                @click="validationForm"
              >
                {{ requiere2fa ? 'Verificar' : 'Iniciar Sesión' }}
              </b-button>
            </b-form>
          </validation-observer>

         
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import axios from '@axios'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useJwt from '@/auth/jwt/useJwt'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      userEmail: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
      errores: '',
      requiere2fa: false,
      codigo: '',
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    validationForm() {      
      this.$refs.loginValidation.validate().then(success => {
        if (success) {


            const dataUser = {
                email: this.userEmail,
                password: this.password
            }

            //crear usuario
            /*axios
                .post("/usuarios",{nombre: "Harber",user:"erp@harberlondon.com",pass:"Harber-2015"})
                .then(response => {
                    return response.data;
                })
                .then(res => {
                
                   console.log(res);
                    
                }).catch(error =>{
                  console.log(error);
                    this.errores = "Usuario o contraseña.";
                });*/

            /*axios
                .post("/auth/login",dataUser)
                .then(response => {
                    return response.data;
                })
                .then(res => {

                   let userData = {
                        "id": 1,
                        "fullName": res.nombre,
                        "username": res.nombre,
                        "avatar": "/img/13-small.d796bffd.png",
                        "token": res.token
                    }

                    localStorage.setItem('userData', JSON.stringify(userData))

                    this.$router.push({ path: '/' })        
                         
                }).catch(error =>{
                  console.log(error);
                    this.errores = "Usuario o contraseña incorrectasdgf.";
                });*/

          this.errores = ''
          useJwt.login({
            email: this.userEmail,
            password: this.password,
            codigo: this.requiere2fa ? this.codigo : undefined,
          })
            .then(response => {

              const userData  = response.data

              // El usuario tiene 2FA: pedir el código y reenviar
              if (userData.requiere2fa) {
                this.requiere2fa = true
                return
              }

              useJwt.setToken(userData.accessToken)
              //useJwt.setRefreshToken(response.data.refreshToken)
              localStorage.setItem('userData', JSON.stringify(userData))
              localStorage.setItem('permisos', JSON.stringify(userData.permisos || {}))

              this.$router.push({ path: '/' })
            })
            .catch(error => {
              console.log('login error:', error)
              if (error.response) {
                // El servidor respondió (ej. 400/401) -> credenciales o código 2FA
                this.errores = this.requiere2fa
                  ? ((error.response.data && error.response.data.msg) || 'Código de verificación incorrecto.')
                  : "Usuario o contraseña incorrecta.";
              } else {
                // No hubo respuesta del servidor -> problema de red/conexión
                this.errores = "No se puede conectar con el servidor (" + (axios.defaults.baseURL || '') + "). Revisa que el backend esté arrancado y accesible.";
              }
            })


          //login sin bd
          /*if(this.userEmail == "erp@harberlondon.com" && this.password == "Harber-2015")
          {            
            this.errores = "";
            let userData = {
                "id": 1,
                "fullName": "Harber",
                "username": "Harber",
                "avatar": "/img/13-small.d796bffd.png",
                "email": "erp@harberlondon.com",
                "role": "admin",
                "ability": [
                    {
                        "action": "manage",
                        "subject": "all"
                    }
                ],
                "extras": {
                    "eCommerceCartItemsCount": 5
                }
            }

            localStorage.setItem('userData', JSON.stringify(userData))

            this.$router.push({ path: '/' })

          }
          else
          {
            this.errores = "Usuario o contraseña incorrecta";
          }*/

        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
